import { openDatabase } from '@/helper/idb';
import { Product } from '@/data/productCategory/product/product';
import { ProductCategory } from '@/data/productCategory/productCategory';
import { FontFamily } from '@/model/fontManager/fontFamily/fontFamily';
import LocalFont, { LocalFontParams } from '@/model/fontManager/localFont';
import { DebugHelper } from '@/helper/debugHelper'

export default { allCategories, allAvailableFonts };

// NAMEとVERSIONは、Electronの方と一致させる
const DB_NAME = 'labelyasan';
const DB_VERSION = 201903210751;

const STORE_PRODUCT = 'product-categories';
const STORE_FONT = 'fonts';

export function allAvailableFonts(): Promise<FontFamily[]> {
    return new Promise(resolve => {
        open().then(db => {
            const tx = db.transaction(STORE_FONT);
            const st = tx.objectStore(STORE_FONT);
            const gt = st.getAll();
            gt.onsuccess = e => {
                const fonts = (e.target as IDBRequest<LocalFontParams[]>).result;
                var fontFamilyList = fonts.map(font => new LocalFont(font).toFont());
                resolve(deduplicateFonts(fontFamilyList));
            };
        });
    });
}

// 重複したフォントを削除する
function deduplicateFonts(fonts : FontFamily[]) : FontFamily[]
{
    var newFont : FontFamily[] = [];
    fonts.forEach(function(font){
        // 重複を調べる
        var isDuplicated = false;
        for(var i = 0; i < newFont.length; ++i)
        {
            if(newFont[i].id == font.id)
            {
                // 重複
                isDuplicated = true;
                break;
            }
        }
        // 重複していなければ追加
        if(!isDuplicated) newFont.push(font);
    });

    return newFont;
}

export function allCategories(filterProducts: (products: Product[]) => Product[]): Promise<ProductCategory[]> {
    return new Promise((resolve, reject) => {
        open().then(db => {
            const tx = db.transaction(STORE_PRODUCT);
            const st = tx.objectStore(STORE_PRODUCT);
            const rq = st.openCursor();
            let categories: ProductCategory[] = [];
            rq.onsuccess = e => {
                const cursor = (e.target as IDBRequest<IDBCursorWithValue>).result;
                if (cursor) {
                    const category = cursor.value as ProductCategory;
                    category.productList = filterProducts(category.productList);
                    if (category.productList.length > 0) {
                        categories.push(category);
                    }
                    cursor.continue();
                } else {
                    resolve(categories);
                }
            };
            rq.onerror = reject;
        });
    });
}

/**
 * idbに接続する
 */
function open(): Promise<IDBDatabase> {
    return openDatabase(DB_NAME, DB_VERSION, db => {
        // Electron側で初期化されれば実行されないはず
        // TODO Electronの時は通らないことをチェックしてVERSIONの指定ミスを拾うべきか？
        migrateProductCategories(db);
        migrateFonts(db);
    });
}

function migrateProductCategories(db: IDBDatabase) {
    if (db.objectStoreNames.contains(STORE_PRODUCT)) {
        db.deleteObjectStore(STORE_PRODUCT);
    }
    const pc = db.createObjectStore(STORE_PRODUCT, { keyPath: 'seq', autoIncrement: true });
    pc.createIndex('id', 'id');
}

function migrateFonts(db: IDBDatabase) {
    if (db.objectStoreNames.contains(STORE_FONT)) {
        db.deleteObjectStore(STORE_FONT);
    }
    const st = db.createObjectStore(STORE_FONT, { keyPath: 'name' });
    st.createIndex('family', 'family');
}
